//////////////////////////////////////////////////////////////////////
//
//  09/26/18
//  src/store/reducers/index.js
//
//  This combines all the individual reducers into a single reducer.
//

import { combineReducers } from "redux";
//import currentUser from "./currentUser";
//import messages from "./messages";
import errors from "./errors";
import navbar from "./navbar";

//
//  Note: In Redux, all reducers get called regardless of the action,
//  so inside each one you have to return the original 'state' if the
//  action is not applicable.
//
const rootReducer = combineReducers({
//  currentUser,
//  errors,
//  messages
  navbar,
  errors
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/index.js